module.exports = {
  title: 'Jcar',
  baseUrl: process.env.VUE_APP_BASE_URL
}
